import { apiRequest } from '@utils/request';
import { ReitOfferingVintage } from 'types/reit-offering-vintage';

export async function getReitOfferingVintage(reitOfferingVintageId: string): Promise<ReitOfferingVintage> {
	const response = await apiRequest.get(`/reit-offering-vintage/${reitOfferingVintageId}`);
	return response.data;
}
